<template>
    <div style="background:rgba(0,0,0,255) !important;width:100%;height:100%;padding:100px;"
        :style="{'background':green?'#00ff00':'transparent'}"
    >
      <video v-show="!green" id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="pointer-events: none;z-index: -1;filter: hue-rotate( 215deg);brightness(1.5)">
        <source :src="require('../assets/white_flare.webm')" type="video/webm">

      </video>
      <v-img
          v-if="!green"
          :src="'https://hihat.io/api/images/soh_bg.jpg'"
          style="position: absolute;z-index: -1;width:100%;height:100%;top:0;left:0;opacity: 1;pointer-events: none;"
      >

      </v-img>


      <v-row style="height:570px;width:100%;background:transparent;">
        <v-col cols="2" align="center">
          <v-list style="padding-bottom:4px;max-width:350px;height:570px;" dark >
            <v-list-item>
              <h2 style="text-align: center;width:100%;">Senaste Donationer</h2>
            </v-list-item>
            <v-list-item

                link
                v-for="(donation, i) in latest"
                :key="i"
                dark
                :style="{'background':colors[0][i % 2]}"


            >


              <v-chip label
                      :color=colorMe(donation.AMOUNT)
                      class="white--text"
              >

                <b style="font-size:16px;">{{donation.SENDER_NAME}}</b>
                <v-chip
                    :dark=true

                    style="background: transparent;font-size:0.8em;padding-left: 10px;opacity: 0.7; margin-right: -8px;"
                >
                  <span style="font-size:12px;">{{timePassed(donation.TIME_PASSED)}}</span>
                </v-chip>
              </v-chip>



              <v-spacer></v-spacer>
              <v-chip style="font-size:16px;" color="transparent" :ripple="false"><b>{{donation.AMOUNT}} kr</b></v-chip>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="8" align="center">
          <v-card dark flat style="width:100%;height:100%;">
            <v-row v-if="top_streamers" style="width:100%;height:100%;">
              <v-col  v-for="(streamer,index) in top_streamers" :key="index" cols="3">
                <v-list-item   style="border-radius:5px;"              :style="{'background':colors[0][index % 2]}"
                >
                  <v-list-item-avatar color="grey"><v-img><img :src="'/api/images/users/'+streamer.SID+'.png'" @error="function(event){alternate_image(event,streamer.USER_NAME)}"/></v-img></v-list-item-avatar>
                  <v-list-item-content style="text-align: left;">
                    <v-list-item-title ><h3><span style="margin-right:10px;">{{index+1}}.</span>{{streamer.USER_NAME}} </h3></v-list-item-title>
                    <v-list-item-subtitle style="font-size:16px;">{{parseInt(streamer.AMOUNT_DONATED)}} kr ({{((streamer.AMOUNT_DONATED/amount_donated)*100).toFixed(1)}}%)</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card>
          </v-col>
        <v-col cols="2" align="center">
          <v-list style="padding-bottom:4px;max-width:350px;height:570px;" dark >
            <v-list-item>
              <h2 style="text-align: center;width:100%;">Topp Donation</h2>
            </v-list-item>

            <v-list-item
                v-for="(donation, i) in top"
                :key="i"
                dark
                :style="{'background':colors[0][i % 2]}"

            >
              <v-chip label
                      :color=colorMe(donation.AMOUNT_DONATED)
                      class="white--text"
              >
                <b style="font-size:16px;">{{donation.SENDER_NAME}}</b>

              </v-chip>
              <v-spacer></v-spacer>
              <v-chip style="font-size:16px;" color="transparent" :ripple="false"><b>{{donation.AMOUNT_DONATED}} kr</b></v-chip>
            </v-list-item>
          </v-list>
        </v-col>


      </v-row>

      <v-card flat dark style="width:100%;height:300px;margin-top:40px;background: transparent">
        <v-card-text style="padding-left:40px;padding-right:40px;">


        <v-row align="center" justify="center" style="margin-left:40px;margin-right:40px;">

          <v-col cols="12" style="z-index: 1">

            <h1 style="color:white;z-index: 1;text-shadow:0px 0px 10px black" class="display-2">
              Next Goal:  <b>{{current_milestone}}</b> kr
            </h1>


          </v-col>

            <v-col cols="12" style="z-index: 1;">

                <v-progress-linear
                        :value="is_celebrate?0:percentage_donated"
                        color="#00c0ff"
                        height="150"
                        style="background: #1d1d1d;"
                        rounded
                        striped
                        :class="is_celebrate?'celebrate':''"
                >

                  <v-img
                      v-show="!is_celebrate"

                      style="position: absolute;z-index: -1;height:150px;left:0;top:0;mix-blend-mode: overlay; opacity: 0.3;filter: blur(1px) brightness(1.5);"
                      :style="{'width':`${percentage_donated}%`}"
                      :src="'https://media1.giphy.com/media/xT9Ighw18Ay7f0cIjS/giphy.gif'"

                  >

                  </v-img>
                  <v-fade-transition>
                  <v-img
                      v-show="is_celebrate"
                      style="position: absolute;z-index: -1;height:150px;left:0;top:0;mix-blend-mode: overlay; opacity: 0.7;filter: blur(1px) brightness(1.5);width:100%;"
                      :src="'https://cdnb.artstation.com/p/assets/images/images/010/143/095/original/nadezhda-odinokova-magic-shockwave-2.gif'"

                  >

                  </v-img>
                  </v-fade-transition>
                    <h1 style="color:white;text-shadow:0px 0px 10px black" class="display-4">
                    <b>{{amount_donated}}</b> kr
                    </h1>

                </v-progress-linear>
            </v-col>
        </v-row>
        </v-card-text>

      </v-card>
    </div>

</template>

<script>
    export default {
        name: "Charity",
        data(){
            return{
              top_streamers:null,
              green:false,
              new_donation_pos:{x:100,y:300},
              new_donation:null,
              new_donation_flare:false,
              categories:["Senaste","Stream","Dono"],
              latest:[],
              top48:[],
              top:[],
              colors:[["rgba(45,45,45,0.8)","rgba(36,36,36,0.8)"],["rgba(240,240,240,1)","rgba(250,250,250,1)"]],
              has_celebrated:true,
              is_celebrate:false,
                amount_donated:0,
              milestones:[5000,10000,25000,50000,75000,100000,150000,200000,250000,300000,350000,450000,500000,550000,600000,672491,800000,1000000,1250000,1500000,1500000,1750000,2000000,3000000,9000000,99000000],
            }
        },
        computed:{
            percentage_donated:function(){


                return (this.amount_donated/this.current_milestone)*100;
            },
            current_milestone:function(){

                for(let i=0;i<this.milestones.length;i++){
                    if(this.amount_donated<this.milestones[i]){
                        return this.milestones[i]
                    }
                }
                return 2000000
            }
        },
        mounted:function(){
          if(window.location.search.includes("green")){
            this.green=true;
          }
          let self=this;
          self.get_amount();
          self.get_top_stream();
          self.get_top_streamers();

          self.get_top_donators();
          self.get_amount();
          self.get_latest()
            setInterval(function(){
              self.get_top_stream();
              self.get_top_donators();
              self.get_top_streamers();

              self.get_amount();
              self.get_latest()
            },5000)
        },

      watch:{
        current_milestone:function(){
          let self=this;
          if(this.has_celebrated){
            this.is_celebrate=true;
            setTimeout(function(){
              self.is_celebrate=false;
            },1000)
          }

        }
      },
        methods:{
          get_top_streamers:function(){
            let http = new XMLHttpRequest();
            http.withCredentials = true;


            let url = '/api/BCF_top_20_streamers';
            http.open('GET', url, true);
            let self=this;
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            http.onreadystatechange = function () {//Call a function when the state changes.


              if (http.readyState === 4 && http.status === 200) {
                let respObj = JSON.parse(http.response);
                self.top_streamers=respObj;
              }

            };
            http.send();
          },
          colorMe(amount){
            if(parseInt(amount)>499){
              return "orange"
            }
            else if(parseInt(amount)>99){
              return "purple"
            }
            else if(parseInt(amount)>49){
              return "blue"
            }
            else if(parseInt(amount)>20){
              return "green"
            }
            else{
              return "#3f3f3f"
            }
          },

          timePassed(time){
            if(time>6048000){
              return "10+ v"
            }
            else if(time>1209600){
              return `${Math.floor(time/1209600)} w`
            }
            else if(time>1209600){
              return `${Math.floor(time/1209600)} w`
            }
            else if(time>86400){
              return `${Math.floor(time/86400)} d`
            }
            else if(time>86400){
              return `${Math.floor(time/86400)} d`
            }
            else if(time>3600){
              return `${Math.floor(time/3600)} h`
            }
            else if(time>120){
              return `${Math.floor(time/60)} m`
            }
            else{
              return "nu"
            }
          },
          get_top_stream(){
            let http = new XMLHttpRequest();
            http.withCredentials = true;
            let url = '/api/BCF_top_streamers';

            http.open('GET', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            let self=this;
            http.onreadystatechange = function() {

              if(http.readyState === 4 && http.status === 403) {

                console.log("error");

              }
              else if(http.readyState === 4 && http.status === 200){
                let data = JSON.parse(http.response);
                self.top48=data;

              }

            };
            http.send();

          },
          get_top_donators(){
            let http = new XMLHttpRequest();
            http.withCredentials = true;
            let url = '/api/BCF_top_donators';

            http.open('GET', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            let self=this;
            http.onreadystatechange = function() {

              if(http.readyState === 4 && http.status === 403) {

                console.log("error");

              }
              else if(http.readyState === 4 && http.status === 200){
                let data = JSON.parse(http.response);
                self.top=data;

              }

            };
            http.send();

          },
          get_latest(){
            let http = new XMLHttpRequest();
            http.withCredentials = true;
            let url = '/api/BCF_latest_donations'
            http.open('GET', url, true);
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            let self=this;
            http.onreadystatechange = function() {

              if(http.readyState === 4 && http.status === 403) {

                console.log("error");

              }
              else if(http.readyState === 4 && http.status === 200){
                let data = JSON.parse(http.response);
                self.latest=data;
                self.new_donation=data[0];
                self.new_donation_flare=true;
                self.new_donation_pos.x=100+(window.innerWidth-200)*Math.random();
                self.new_donation_pos.y=100+(window.innerHeight-200)*Math.random();
                setTimeout(function(){
                  self.new_donation=null;


                },2500);
                setTimeout(function(){
                  self.new_donation_flare=false;
                },500);

              }

            };
            http.send();

          },
            get_amount:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
              let url = '/api/BCF_sum_donated';

                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);

                        self.amount_donated=parseInt(data.AMOUNT_DONATED);



                    }

                };
                http.send();
            }
        }
        /*
        * <v-list style="padding-bottom:4px;max-width:350px;height:570px;" dark >
            <v-list-item>
              <h2 style="text-align: center;width:100%;">Topp Stream</h2>
            </v-list-item>

            <v-list-item
                v-for="(donation, i) in top48"
                :key="i"
                dark
                :style="{'background':colors[0][i % 2]}"


            >
              <v-chip label
                      :color=colorMe(donation.AMOUNT_DONATED)
                      class="white--text"
              >
                <b style="font-size:16px;">{{donation.USER_NAME}}</b>

              </v-chip>
              <v-spacer></v-spacer>
              <v-chip style="font-size:16px;" color="transparent" :ripple="false"><b>{{donation.AMOUNT_DONATED}} kr</b></v-chip>
            </v-list-item>
          </v-list>*/


    }
</script>

<style>
    ::-webkit-scrollbar {
        width: 0 !important;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent !important;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: transparent !important;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background:transparent !important;
    }

    .celebrate {
      text-align: center;
      -webkit-animation: celebrate_now 1s ease-in-out forwards;
      -moz-animation: celebrate_now 1s ease-in-out forwards;
      animation: celebrate_now 1s ease-in-out forwards;
    }


    .glow {
      text-align: center;
      -webkit-animation: glow 1s ease-in-out forwards;
      -moz-animation: glow 1s ease-in-out forwards;
      animation: glow 1s ease-in-out forwards;
    }

    @-webkit-keyframes celebrate_now {
      0% {
          transform: scale(1.0);

      }
      50%{
        transform: scale(0.6);
      }
      70%{
        transform: scale(1.05);
      }
      100% {
        transform: scale(1.0);

      }
    }


    @-webkit-keyframes glow {
      from {

        box-shadow: inset  0 0 10px rgba(255, 255, 255, 0.91), inset  0 0 20px rgba(255, 255, 255, 0.8), inset 0 0 30px #545454, inset  0 0 40px rgba(0, 203, 230, 0.74), inset 0 0 50px rgba(0, 176, 230, 0.56),inset  0 0 60px rgba(29, 163, 220, 0.88), inset 0 0 70px rgba(0, 203, 230, 0.74);
      }
      to {
        box-shadow: inset 0 0 20px rgba(255, 255, 255, 0.95), inset  0 0 30px rgba(77, 240, 255, 0.44), inset 0 0 40px rgba(77, 213, 255, 0.66),inset  0 0 50px rgba(77, 166, 255, 0.66), inset 0 0 60px rgba(77, 193, 255, 0.68), inset 0 0 70px rgba(92, 250, 175, 0.87), inset 0 0 80px rgba(0, 188, 230, 0.86);
      }
    }
</style>
